import React from 'react';

import { IconButton } from '@gogame/components';
import { withFormField } from '@gogame/form';

export default withFormField()(
  ({ value, onChange, iconChecked, iconUnchecked, tooltip }) => {
    const handleClick = React.useCallback(
      (e) => {
        onChange(e, !value);
      },
      [onChange, value]
    );

    return (
      <IconButton
        icon={value ? iconChecked : iconUnchecked}
        onClick={handleClick}
        tooltip={tooltip}
      />
    );
  }
);
